import template from './add-activity.html'

export let addActivity = {
  bindings: {
    disable: '<',
    module: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['$stateParams', '$mdDialog', 'Validations', 'GlobalConfig', 'Ramda', 'ReviewSrv', 'Util', 'WorkPlanModalSrv',
    function addActivityCtrl ($stateParams, $mdDialog, Validations, GlobalConfig, Ramda, ReviewSrv, Util, WorkPlanModalSrv) {
      const {
        isProjectDesignType,
        isProductsType,
        isColaborationSpaceType,
        isInvestigationType,
        isResultsTransferType,
        isCommitteeParticipationType,
        isRolesType,
        isOtherActivitiesType,
        isCommunityType,
        isTeacherDevelopmentType,
        inConsolidation,
        inAcademicManagement,
        inInvestigation,
        isDoctoralEducationType
      } = Validations

      const addActivity = (activity) => {
        services({activityTypeId: Number(activity)})
      }

      const services = activity => {
        switch (true) {
          // Investigation
          case isProjectDesignType(activity):
            WorkPlanModalSrv.addInvestigationProjectsFormulation()
            return 'Propuesta de investigación'
          case isProductsType(activity):
            WorkPlanModalSrv.addInvestigationProducts()
            return 'Productos'
          case isColaborationSpaceType(activity):
            WorkPlanModalSrv.addInvestigationSpace()
            return 'Espacios de colaboración'
          case isInvestigationType(activity):
            WorkPlanModalSrv.addInvestigationTrainingResearch()
            return 'Investigación'
          case isResultsTransferType(activity):
            WorkPlanModalSrv.addInvestigationResultsTransfer()
            return 'Transferencia de resultados'
          // Academic Management
          case isCommitteeParticipationType(activity):
            WorkPlanModalSrv.addAcademicManagementCommitteParticipation()
            return 'Participación en comité'
          case isRolesType(activity):
            WorkPlanModalSrv.addAcademicManagementRole()
            return 'Roles'
          case isOtherActivitiesType(activity):
            WorkPlanModalSrv.addAcademicManagementActivity()
            return 'Otra actividad'
          // Consolidation CP
          case isTeacherDevelopmentType(activity):
            WorkPlanModalSrv.addConsolidationCourseExternal()
            return 'Cursos externos'
          case isCommunityType(activity):
            WorkPlanModalSrv.addConsolidationLearningComunity()
            return 'Comunidades de aprendizaje'
          case isDoctoralEducationType(activity):
              WorkPlanModalSrv.addDoctoralEducation()
              return 'Formación doctoral'
        }
      }

      const activitiesList = module => {
        switch (true) {
          case inConsolidation(module):
            return [
              {name: 'Cursos externos', id: GlobalConfig.activityTypeId.teacherDevelopment},
              {name: 'Comunidades de aprendizaje', id: GlobalConfig.activityTypeId.community},
              {name: 'Formación doctoral', id: GlobalConfig.activityTypeId.doctoralEducation}
            ]
          case inAcademicManagement(module):
            if ($stateParams.stage != GlobalConfig.workplanStages.execution) {
              return [
                {name: 'Participación en comité', id: GlobalConfig.activityTypeId.committeeParticipation},
                {name: 'Rol', id: GlobalConfig.activityTypeId.roles},
                {name: 'Actividad', id: GlobalConfig.activityTypeId.otherActivities}
              ]
            } else {
              return [
                {name: 'Participación en comité', id: GlobalConfig.activityTypeId.committeeParticipation},
                {name: 'Actividad', id: GlobalConfig.activityTypeId.otherActivities}
              ]
            }
          case inInvestigation(module):
            return [
              {name: 'Formulación de proyectos', id: GlobalConfig.activityTypeId.projectDesign},
              {name: 'Producto', id: GlobalConfig.activityTypeId.products},
              {name: 'Espacio de colaboración', id: GlobalConfig.activityTypeId.colaborationSpace},
              {name: 'Formación de investigación', id: GlobalConfig.activityTypeId.investigation},
              {name: 'Transferencia de resultados', id: GlobalConfig.activityTypeId.resultsTransfer}
            ]
        }
      }

      angular.extend(this, {
        activityTypes: activitiesList(this.module),
        activity: null,
        addActivity: addActivity
      })

      this.$onInit = () => {
        console.log(this.activityTypes)
      }
    }
  ]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/header/add-activity.js